import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import {
  USUARIOS_REPROVAR_CADASTRO_BEGIN,
  USUARIOS_REPROVAR_CADASTRO_SUCCESS,
  USUARIOS_REPROVAR_CADASTRO_FAILURE,
  USUARIOS_REPROVAR_CADASTRO_DISMISS_ERROR,
} from './constants';
import * as Services from '../../../sdk/services';

export function reprovarCadastro(registro, callback) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: USUARIOS_REPROVAR_CADASTRO_BEGIN,
    data: registro,
    callback,
  };
}

export function dismissReprovarCadastroError() {
  return {
    type: USUARIOS_REPROVAR_CADASTRO_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on USUARIOS_REPROVAR_CADASTRO_BEGIN actions
export function* doReprovarCadastro(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  const UsuarioApi = new Services['UsuarioApi']();
  try {
    // Do Ajax call or other async request here. delay(20) is just a placeholder.
    let retorno = yield UsuarioApi.reprovarCadastroPendente(action.data.codigo);
    if (!retorno) {
      res = action.data;
    } else {
      throw retorno;
    }
  } catch (err) {
    yield put({
      type: USUARIOS_REPROVAR_CADASTRO_FAILURE,
      data: { error: err },
    });

    if (action.callback) {
      action.callback(USUARIOS_REPROVAR_CADASTRO_FAILURE);
    }
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: USUARIOS_REPROVAR_CADASTRO_SUCCESS,
    data: res,
  });

  if (action.callback) {
    action.callback(USUARIOS_REPROVAR_CADASTRO_SUCCESS);
  }
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchReprovarCadastro() {
  yield takeLatest(USUARIOS_REPROVAR_CADASTRO_BEGIN, doReprovarCadastro);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case USUARIOS_REPROVAR_CADASTRO_BEGIN:
      return {
        ...state,
        reprovarCadastroPending: true,
        reprovarCadastroError: null,
      };

    case USUARIOS_REPROVAR_CADASTRO_SUCCESS:
      return {
        ...state,
        registro: action.data,
        registros: state.registros.filter(registro => registro.codigo !== action.data.codigo),
        reprovarCadastroPending: false,
        reprovarCadastroError: null,
      };

    case USUARIOS_REPROVAR_CADASTRO_FAILURE:
      return {
        ...state,
        reprovarCadastroPending: false,
        reprovarCadastroError: action.data.error,
      };

    case USUARIOS_REPROVAR_CADASTRO_DISMISS_ERROR:
      return {
        ...state,
        reprovarCadastroError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/usuarios/redux/reprovarCadastro.js